import React from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import { useLang } from '@/i18n';
import EcoTabImgs, { EcoTabImgsItem } from 'eco-design/sections-test/eco-tab-imgs';
import css from './index.module.scss';
import { useRouter } from 'next/router';

interface Props {}

const TabImgs: React.FC<Props> = ({}) => {
    const { t } = useLang('powerBank.Tab');
    const { locale = 'us' } = useRouter();

    const items: EcoTabImgsItem[] = [
        {
            tabLabel: t('tab1'),
            tabValue: '0',
            imgs:
                locale === 'ph'
                    ? [
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1762504748990/pc_Remote%20work_01.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1762504748788/m_Remote%20work_01.jpg',
                          },
                      ]
                    : [
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1753259690410/pc_Remote%20work_01.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1753259667568/m_Remote%20work_01.jpg',
                          },
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1753259689854/pc_Remote%20work_02.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1753259668114/m_Remote%20work_02.jpg',
                          },
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1748929942982/pc_Remote%20work_03.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1748929941830/m_Remote%20work_03.jpg',
                          },
                      ],
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('tab1'), list_name: t('title') || 'none' },
        },
        {
            tabLabel: t('tab2'),
            tabValue: '1',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('tab2'), list_name: t('title') || 'none' },
            imgs:
                locale === 'ph'
                    ? [
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1762504749230/pc_Travel_01.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1762504749436/m_Travel_01.jpg',
                          },
                      ]
                    : [
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1753259690821/pc_Travel_01.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1753259668901/m_Travel_01.jpg',
                          },
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1753259691440/pc_Travel_02.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1753259668496/m_Travel_02.jpg',
                          },
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1748930408322/pc_Travel_03.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1748930408108/m_Travel_03.jpg',
                          },
                      ],
        },
        {
            tabLabel: t('tab3'),
            tabValue: '2',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('tab3'), list_name: t('title') || 'none' },
            imgs:
                locale === 'ph'
                    ? [
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1762504749654/pc_at%20home_02.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1762504748709/m_at%20home_01.jpg',
                          },
                      ]
                    : [
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1753259689293/pc_at%20home_02.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1753259667058/m_at%20home_01.jpg',
                          },
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1753259689400/pc_at%20home_03.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1753259668425/m_at%20home_02.jpg',
                          },
                          {
                              pc: 'https://websiteoss.ecoflow.com/upload/image/1748930517726/pc_at%20home_01.jpg',
                              pad: 'https://websiteoss.ecoflow.com/upload/image/1748930517481/m_at%20home_03.jpg',
                          },
                      ],
        },
    ];

    return (
        <>
            <EcoSpace />
            <EcoTabImgs title={t('title')} className={css.comp} items={items} />
        </>
    );
};
export default TabImgs;
